export default "__VITE_ASSET__2a7b97c6__"